module.exports = __webpack_public_path__ + "static/img/10.52251ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/canoa-quebrada/10.jpg
// module id = /sXE
// module chunks = 1